import { AssignPeoplePermissionsEnum } from '../enums/assignPeoplePermissions.enum';

import type { PlannerItemStatusesEnum } from '../enums/plannerItemStatuses.enum';
import type { ItemUserModel } from '../models/itemUser.model';

export const transformToAssignUserSelectValueWithRole = (
  arr: ItemUserModel[],
  ownerId?: number,
  status?: PlannerItemStatusesEnum,
  assignRole?: AssignPeoplePermissionsEnum,
) => {
  return arr.map((item: ItemUserModel) => ({
    ...item,
    value: item.id,
    isOwner: item.id === ownerId,
    role:
      item.role && Object.values(AssignPeoplePermissionsEnum).includes(item.role)
        ? item.role
        : assignRole || AssignPeoplePermissionsEnum.editor,
    label: item.full_name ? item.full_name : `${item.first_name} ${item.last_name}`,
    status: item.is_fake
      ? undefined
      : item.status
        ? item.status
        : !item.is_fake && status
          ? status
          : undefined,
  }));
};
